import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import { Worker } from '@react-pdf-viewer/core';
// Import the main component
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { zoomPlugin } from '@react-pdf-viewer/zoom';


    

const emails = ['username@gmail.com', 'user02@gmail.com'];


const SimpleDialogBox = (props) => {
  const zoomPluginInstance = zoomPlugin();
  const { Zoom } = zoomPluginInstance;

  const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const { onClose, selectedValue, open ,resume} = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };
    return (
        <Dialog onClose={handleClose} open={open} 
        
        sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                height:'100%',
                maxWidth: "1500px",
                  // Set your width here
              },
            },
          }}
      
        
        >
         

        {
            resume!==null&&(
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
              <Viewer fileUrl={resume}  plugins={[defaultLayoutPlugin]}/>
              
          </Worker>
            )
        }
        
      </Dialog>
    );
};

export default SimpleDialogBox;